// App.jsx
import React, { useState, useMemo, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { useQuery } from 'react-query'
import { PublicRoute, PrivateRoute } from './Frontend/Routes'
import Home from './Frontend/HomeDR12'
import Login from './Frontend/LoginDR12/Login.jsx'
import OAuthAuthorize from './Frontend/LoginDR12/OAuthAuthorize.jsx'
import StepOne from './Frontend/SignUpDr12/index.jsx'
import Dashboard from './Frontend/DashboardMain/index'
import ForgotPassword from './Frontend/ForgotPassword'
import resetpassword from './Frontend/ResetPassword'
import { getAccount } from './Api'
import { UserContext } from './Frontend/UserContext'
import './App.css'

export default function App () {
  const session = localStorage.getItem('dfp/session')
  const oldPlan = localStorage.getItem('dfp/plan')
  const { data: accountInfo } = useQuery('accountApp', getAccount, {
    enabled: !!session
  })
  const accountPlan = accountInfo?.data?.plan_id

  const [value, setValue] = useState(null)
  const providerValue = useMemo(() => ({ value, setValue }), [value, setValue])

  useEffect(() => {
    if (session && accountPlan && oldPlan !== accountPlan) {
      localStorage.setItem('dfp/plan', accountPlan)
    }
  }, [session, accountPlan, oldPlan])

  return (
    <Router>
      <UserContext.Provider value={providerValue}>
        <Switch>
          {/* Public Routes */}
          <PublicRoute
            exact
            path='/forgot-password'
            component={ForgotPassword}
            restricted={false}
          />
          <PublicRoute
            exact
            path='/reset-password'
            component={resetpassword}
            restricted={false}
          />
          <PublicRoute path='/sign-up' component={StepOne} restricted={true} />
          <PublicRoute path='/login' component={Login} restricted={false} />
          <PublicRoute path='/home' component={Home} restricted={false} />
          {/* Plain Route, not PublicRoute: renders regardless of an existing
              portal session rather than redirecting an already-logged-in
              visitor away, since this is a third-party authorization
              confirmation, not a normal login page. */}
          <Route path='/oauth/authorize' component={OAuthAuthorize} />
          {/* Private Routes */}
          <PrivateRoute path='/' component={Dashboard} />
        </Switch>
      </UserContext.Provider>
    </Router>
  )
}
